/**
 * File: GridCard.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.3.0
 * Created: 2025-11-11
 * Last Updated: 2026-04-15
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { Link } from "react-router-dom";

// Local project files
import { LinkButton } from "../ui/Buttons";
import Tag from "./Tag";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function GridCard({
    header,
    subheader,
    description,
    buttonText,
    buttonLink,
    image,
    icon = null,
    tagLabel = null,
}) {
    return (
        <>
            <Link to={buttonLink}>
                <div className="grid-card">
                    <div className="grid-card__container">
                        {icon && (
                            <img src={icon} className="grid-card__icon"></img>
                        )}
                        <h4 className="grid-card__header">{header}</h4>
                        {tagLabel && <Tag label={tagLabel} />}
                    </div>
                    <h3>{subheader}</h3>
                    <p className="grid-card__description">{description}</p>
                    <LinkButton text={buttonText} link={buttonLink} />
                    <img src={image} className="grid-card__image"></img>
                </div>
            </Link>
        </>
    );
}

export default GridCard;
